import React from 'react';
import Loader from './Loader';

const Table = ({
  columns = [],
  data = [],
  onRowClick,
  keyExtractor = (row, i) => {
    if (row && row.id !== undefined && row.id !== null && row.id !== '') {
      return row.id;
    }
    if (row && row._id !== undefined && row._id !== null && row._id !== '') {
      return row._id;
    }
    return `row-${i}`;
  },
  className = '',
  isLoading = false,
  getRowProps = () => ({}),
}) => {
  return (
    <div className={`overflow-x-auto rounded-xl ${className}`}>
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            {columns.map((col, i) => (
              <th
                key={col.accessor || col.header || `col-${i}`}
                className={`px-3 py-2 text-left text-xs sm:text-sm font-semibold
    tertiary-text-color
    whitespace-normal break-words ${col.className || ''}`}
              >
                {col.header}
              </th>
            ))}
          </tr>
        </thead>

        <tbody className="bg-white divide-y divide-gray-200">
          {isLoading ? (
            <tr>
              <td colSpan={columns.length} className="px-6 py-10 text-center text-secondary">
                <div className="flex justify-center items-center">
                  <Loader />
                </div>
              </td>
            </tr>
          ) : data.length === 0 ? (
            <tr key="no-data-row">
              <td
                colSpan={columns.length}
                className="px-6 py-4 text-center text-sm tertiary-text-color"
              >
                No data available
              </td>
            </tr>
          ) : (
            data.map((row, rowIdx) => {
              const { className: rowClassName, ...restRowProps } = getRowProps(row);
              const trClassName = ['cursor-pointer hover:bg-gray-50', rowClassName]
                .filter(Boolean)
                .join(' ');
              return (
                <tr
                  key={keyExtractor(row, rowIdx)}
                  className={trClassName}
                  onClick={() => onRowClick?.(row)}
                  {...restRowProps}
                >
                  {columns.map((col, colIdx) => {
                    const content =
                      typeof col.cell === 'function'
                        ? col.cell(row)
                        : typeof col.accessor === 'function'
                          ? col.accessor(row)
                          : row[col.accessor];

                    return (
                      <td
                        key={`${keyExtractor(row, rowIdx)}-${col.accessor || colIdx}`}
                        className={`px-6 py-4 text-sm tertiary-text-color ${col.className || ''} relative`}
                      >
                        {content}
                      </td>
                    );
                  })}
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
